import styled from 'styled-components';

const Wrapper = styled.div`
  /* stylelint-disable -- next who will be here, replace colors with the value of theme config, and remove !important  */
  .svg-fill-gray-dark {
    fill: #2b2b2b !important;
  }

  .svg-stroke-gray-dark {
    stroke: #2b2b2b !important;
  }

  .svg-fill-gray-light {
    fill: #aab7c2 !important;
  }

  .svg-stroke-gray-light {
    stroke: #aab7c2 !important;
  }
  /* stylelint-enable */
`;

const PassDesktopIcon = () => {
  return (
    <Wrapper>
      <svg data-testid='pass-desktop-icon-svg' viewBox='0 0 677 395'>
        <g id='a274fe'>
          <path
            strokeLinecap='round'
            strokeMiterlimit='10'
            strokeWidth='4'
            d='M2 243.66h196.88M216.22 243.94l458.71-.04'
            className='svg-fill-none svg-stroke-gray-dark'
          />
          <rect
            x='523.08'
            y='269.84'
            width='84.33'
            height='20.88'
            rx='2'
            ry='2'
            strokeLinecap='round'
            strokeMiterlimit='10'
            strokeWidth='4'
            className='svg-fill-white svg-stroke-gray-dark'
          />
          <path
            strokeLinecap='round'
            strokeMiterlimit='10'
            strokeWidth='4'
            d='M598.4 279.68h-66.67'
            className='svg-fill-none svg-stroke-gray-dark'
          />
          <path
            strokeLinecap='round'
            strokeMiterlimit='10'
            strokeWidth='4'
            d='M593.33 215.84v44.84h-56.17V179.3h56.17v17.88'
            className='svg-fill-primary-o svg-stroke-gray-dark'
          />
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='4'
            d='M546.16 236.83l13.95-13.94M548 251.17l13.94-13.94'
            className='svg-fill-none svg-stroke-white'
          />
          <path
            d='M593.33 179.3v-13.62a2 2 0 0 0-2-2h-52.17a2 2 0 0 0-2 2v13.62zM537.16 260.68v17a2 2 0 0 0 2 2h52.17a2 2 0 0 0 2-2v-17z'
            strokeMiterlimit='10'
            strokeWidth='4'
            className='svg-fill-white svg-stroke-gray-dark'
          />
          <path
            strokeLinecap='round'
            strokeMiterlimit='10'
            strokeWidth='4'
            d='M553.99 171.3h21.75'
            className='svg-fill-none svg-stroke-gray-light'
          />
          <circle cx='564.87' cy='270.3' r='3.75' className='svg-fill-gray-light' />
          <path
            d='M309.65 325.29h170.9a8.47 8.47 0 0 1 8.44 8.44v42.9a8.47 8.47 0 0 1-8.44 8.44H267.4a8.47 8.47 0 0 1-8.44-8.44v-42.9a8.47 8.47 0 0 1 8.44-8.44h27.22'
            strokeLinecap='round'
            strokeMiterlimit='10'
            strokeWidth='4'
            className='svg-fill-white svg-stroke-gray-dark'
          />
          <rect
            x='269.31'
            y='335.84'
            width='12.66'
            height='11.25'
            rx='2.81'
            ry='2.81'
            className='svg-fill-gray-light'
          />
          <rect x='289' y='335.84' width='12.66' height='11.25' rx='2.81' ry='2.81' className='svg-fill-gray-light' />
          <rect
            x='308.69'
            y='335.84'
            width='12.66'
            height='11.25'
            rx='2.81'
            ry='2.81'
            className='svg-fill-gray-light'
          />
          <rect
            x='328.39'
            y='335.84'
            width='12.66'
            height='11.25'
            rx='2.81'
            ry='2.81'
            className='svg-fill-gray-light'
          />
          <rect
            x='348.08'
            y='335.84'
            width='12.66'
            height='11.25'
            rx='2.81'
            ry='2.81'
            className='svg-fill-gray-light'
          />
          <rect
            x='367.78'
            y='335.84'
            width='12.66'
            height='11.25'
            rx='2.81'
            ry='2.81'
            className='svg-fill-gray-light'
          />
          <rect
            x='387.47'
            y='335.84'
            width='12.66'
            height='11.25'
            rx='2.81'
            ry='2.81'
            className='svg-fill-gray-light'
          />
          <rect
            x='407.17'
            y='335.84'
            width='12.66'
            height='11.25'
            rx='2.81'
            ry='2.81'
            className='svg-fill-gray-light'
          />
          <rect
            x='426.86'
            y='335.84'
            width='12.66'
            height='11.25'
            rx='2.81'
            ry='2.81'
            className='svg-fill-gray-light'
          />
          <rect
            x='446.55'
            y='335.84'
            width='12.66'
            height='11.25'
            rx='2.81'
            ry='2.81'
            className='svg-fill-gray-light'
          />
          <rect
            x='466.25'
            y='335.84'
            width='12.66'
            height='11.25'
            rx='2.81'
            ry='2.81'
            className='svg-fill-gray-light'
          />
          <rect x='279.39' y='349.9' width='12.66' height='11.25' rx='2.81' ry='2.81' className='svg-fill-gray-light' />
          <rect x='299.08' y='349.9' width='12.66' height='11.25' rx='2.81' ry='2.81' className='svg-fill-gray-light' />
          <rect x='318.78' y='349.9' width='12.66' height='11.25' rx='2.81' ry='2.81' className='svg-fill-gray-light' />
          <rect x='338.47' y='349.9' width='12.66' height='11.25' rx='2.81' ry='2.81' className='svg-fill-gray-light' />
          <rect x='358.16' y='349.9' width='12.66' height='11.25' rx='2.81' ry='2.81' className='svg-fill-gray-light' />
          <rect x='377.86' y='349.9' width='12.66' height='11.25' rx='2.81' ry='2.81' className='svg-fill-gray-light' />
          <rect x='397.55' y='349.9' width='12.66' height='11.25' rx='2.81' ry='2.81' className='svg-fill-gray-light' />
          <rect x='417.25' y='349.9' width='12.66' height='11.25' rx='2.81' ry='2.81' className='svg-fill-gray-light' />
          <rect x='436.94' y='349.9' width='12.66' height='11.25' rx='2.81' ry='2.81' className='svg-fill-gray-light' />
          <rect x='456.64' y='349.9' width='12.66' height='11.25' rx='2.81' ry='2.81' className='svg-fill-gray-light' />
          <rect
            x='269.31'
            y='363.97'
            width='12.66'
            height='11.25'
            rx='2.81'
            ry='2.81'
            className='svg-fill-gray-light'
          />
          <rect x='289' y='363.97' width='12.66' height='11.25' rx='2.81' ry='2.81' className='svg-fill-gray-light' />
          <path
            d='M436.71 363.97h-125.2a2.82 2.82 0 0 0-2.81 2.82v5.62a2.82 2.82 0 0 0 2.81 2.82h125.2a2.82 2.82 0 0 0 2.81-2.82v-5.62a2.82 2.82 0 0 0-2.81-2.82z'
            className='svg-fill-gray-light'
          />
          <rect
            x='446.55'
            y='363.97'
            width='12.66'
            height='11.25'
            rx='2.81'
            ry='2.81'
            className='svg-fill-gray-light'
          />
          <rect
            x='466.25'
            y='363.97'
            width='12.66'
            height='11.25'
            rx='2.81'
            ry='2.81'
            className='svg-fill-gray-light'
          />
          <path
            d='M194.07 392.35a22.06 22.06 0 0 1-22-22v-26a21.83 21.83 0 0 1 2.6-10.36 22.13 22.13 0 0 1 19.4-11.64 22.06 22.06 0 0 1 22 22v26a22.06 22.06 0 0 1-22 22z'
            className='svg-fill-white'
          />
          <path
            d='M209.6 328.81a21.89 21.89 0 0 0-15.53-6.46 22.06 22.06 0 0 0-22 22v26a22.06 22.06 0 0 0 22 22 22.06 22.06 0 0 0 22-22v-26a21.78 21.78 0 0 0-.83-6'
            strokeLinecap='round'
            strokeMiterlimit='10'
            strokeWidth='3.838'
            className='svg-fill-none svg-stroke-gray-dark'
          />
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M188.46 353.84h-16M189.65 359.84h-17.19M191.2 365.84h-18.74M193.45 371.84h-20.83M196.27 377.84h-22.31M200.15 383.84h-23.38'
            className='svg-fill-none svg-stroke-gray-dark'
          />
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='4'
            d='M172.46 345.1h43.1M194.06 323.18v21.92'
            className='svg-fill-none svg-stroke-gray-dark'
          />
          <path d='M212.45 43.4a39.75 39.75 0 1 1-68 41.17' fill='#fee782' />
          <path
            d='M170.4 83.39a19.18 19.18 0 0 1-6.88-6.73M196.5 56.68a19.28 19.28 0 0 1-12.24 28.8M105.44 241.9L67.16 133.96M66.04 128.98L111.4 11.43h24'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='4'
            className='svg-fill-none svg-stroke-gray-dark'
          />
          <circle
            cx='66.32'
            cy='128.93'
            r='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='4'
            className='svg-fill-gray-light svg-stroke-gray-dark'
          />
          <path
            d='M136.4 29.8a18.32 18.32 0 1 1 31.33-19z'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='4'
            className='svg-fill-gray-light svg-stroke-gray-dark'
          />
          <path
            d='M219.4 42.82l-88.43 53.53a55.95 55.95 0 0 1 88.9-67'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='4'
            className='svg-fill-gray-light svg-stroke-gray-dark'
          />
          <path
            d='M58.4 272.29v10.07c0 5.44 20.63 9.84 46.08 9.84s46.08-4.4 46.08-9.84v-10.07z'
            strokeMiterlimit='10'
            strokeWidth='4'
            className='svg-fill-gray-light svg-stroke-gray-dark'
          />
          <path
            d='M141.03 265.36c6 1.66 9.55 3.74 9.55 6 0 5.44-20.63 9.84-46.08 9.84s-46.1-4.41-46.1-9.85 20.63-9.84 46.08-9.84a184.56 184.56 0 0 1 25.37 1.67'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='4'
            className='svg-fill-white svg-stroke-gray-dark'
          />
          <path
            d='M92.98 268.35v-22.82a5.77 5.77 0 0 1 5.76-5.76h11.52a5.77 5.77 0 0 1 5.76 5.76v22.82'
            strokeLinecap='round'
            strokeMiterlimit='10'
            strokeWidth='4'
            className='svg-fill-gray-light svg-stroke-gray-dark'
          />
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M125.49 49.19l10.83-6.62M124.07 57.09l13.72-8.38M123.03 64.76l16.69-10.2M122.9 71.87l19.24-11.76M123.89 78.29l20.83-12.72M125.58 84.3l22.88-13.99M127.83 89.95l24.84-15.18'
            className='svg-fill-none svg-stroke-gray-dark'
          />
          <path
            d='M347.4 280.73h77.32a7.11 7.11 0 0 0 7.09-7.09v-1.18c0-3.9-2.94-4.45-7.09-7.09l-10.66-6-6-41.34h-70.57l-6 41.34-11 6c-3.3 2-7.08 3.19-7.08 7.09v1.18a7.11 7.11 0 0 0 7.08 7.09h9.18'
            className='svg-fill-white'
          />
          <path
            d='M347.4 280.73h77.32a7.11 7.11 0 0 0 7.09-7.09v-1.18c0-3.9-2.94-4.45-7.09-7.09l-10.66-6-6-41.34h-70.57l-6 41.34-11 6c-3.3 2-7.08 3.19-7.08 7.09v1.18a7.11 7.11 0 0 0 7.08 7.09h9.18'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='4'
            className='svg-fill-none svg-stroke-gray-dark'
          />
          <path
            d='M501.9 164.05v54.22a6.78 6.78 0 0 1-6.67 6.85H249.9a6.79 6.79 0 0 1-6.67-6.85V22.91a6.79 6.79 0 0 1 6.67-6.85h245.33a6.78 6.78 0 0 1 6.67 6.85v123.42'
            strokeLinecap='round'
            strokeMiterlimit='10'
            strokeWidth='4'
            className='svg-fill-white svg-stroke-gray-dark'
          />
          <path
            d='M262.98 186.41a5 5 0 0 1-4.88-5.09V36.05a5 5 0 0 1 4.88-5.09h220.1a5 5 0 0 1 4.88 5.09v145.27a5 5 0 0 1-4.88 5.09z'
            className='svg-fill-primary-o'
          />
          <path
            d='M483.08 32.96a3 3 0 0 1 2.88 3.09v145.27a3 3 0 0 1-2.88 3.09h-220.1a3 3 0 0 1-2.88-3.09V36.05a3 3 0 0 1 2.88-3.09h220.1m0-4h-220.1a7 7 0 0 0-6.88 7.09v145.27a7 7 0 0 0 6.88 7.09h220.1a7 7 0 0 0 6.88-7.09V36.05a7 7 0 0 0-6.88-7.09z'
            className='svg-fill-gray-dark'
          />
          <path d='M362.4 133.97h-.17' className='svg-fill-primary-o' />
          <path
            strokeLinecap='round'
            strokeMiterlimit='10'
            strokeWidth='4'
            d='M260.88 210.94h26.99'
            className='svg-fill-none svg-stroke-gray-dark'
          />
          <circle
            cx='373.01'
            cy='204.74'
            r='6.2'
            strokeMiterlimit='10'
            strokeWidth='4'
            className='svg-fill-gray-light svg-stroke-gray-dark'
          />
          <circle cx='300.27' cy='210.94' r='3.54' className='svg-fill-gray-dark' />
          <path
            strokeLinecap='round'
            strokeMiterlimit='10'
            strokeWidth='4'
            d='M304.88 44.28h49.99'
            className='svg-fill-none svg-stroke-white'
          />
          <circle cx='294.6' cy='44.28' r='3.54' className='svg-fill-white' />
          <circle cx='282.6' cy='44.28' r='3.54' className='svg-fill-white' />
          <circle cx='270.6' cy='44.28' r='3.54' className='svg-fill-white' />
          <circle
            cx='433.63'
            cy='491.5'
            r='41.25'
            transform='rotate(-20.7 -642.512 469.233)'
            className='svg-fill-white'
          />
          <path
            d='M391.24 120.47c-1.66-4.19-8.16-6.67-13.6-8.32a1.72 1.72 0 0 1-1-1.59 1.82 1.82 0 0 1 .37-1.1 15.4 15.4 0 0 0 4-10.27c0-5.92-3.25-11.67-10-11.67s-10 5.75-10 11.67a15.4 15.4 0 0 0 4 10.27 1.81 1.81 0 0 1 .36 1.1 1.71 1.71 0 0 1-1 1.59c-5.45 1.65-11.94 4.13-13.6 8.32a6.39 6.39 0 0 0-.47 2.41 6 6 0 0 0 4.75 6h31.86a6 6 0 0 0 4.74-6 6.58 6.58 0 0 0-.41-2.41z'
            className='svg-fill-gray-light'
          />
          <path
            strokeLinecap='round'
            strokeMiterlimit='10'
            strokeWidth='4'
            d='M331.67 259.88h66.96'
            className='svg-fill-none svg-stroke-gray-dark'
          />
        </g>
      </svg>
    </Wrapper>
  );
};

export default PassDesktopIcon;
